<template>
  <div id="miiafw-processing">
    <div class="miiafw-processingMessage" :style="{ 'background-image': 'url(' + loadingImageUrl + ')' }">{{ $store.getters['miiaFwStore/loadingMessage'] }}</div>
  </div>
</template>

<script>
export default {
  name: 'MiiaFwLoading',
  data () {
    return {
      loadingImageUrl: null
    }
  },
  created () {
    const currentImage = this.$store.getters['miiaFwStore/loadingImage']
    if (currentImage === null) {
      const img = require('@/assets/img/' + this.$loadingImage + '.gif')
      this.loadingImageUrl = img
      this.$store.commit('miiaFwStore/updateLoadingImage', this.loadingImageUrl)
    } else {
      this.loadingImageUrl = currentImage
    }
  }
}
</script>

<style lang="scss" scoped>
#miiafw-processing {
  display: table;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(255,255,255,0.7);
  z-index: 10001;  /* 10000以上にしないとremodalの背後になる。 */
}

#miiafw-processing .miiafw-processingMessage {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  padding-top: 140px;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 10002;  /* 10000以上にしないとremodalの背後になる。 */
}
</style>
